﻿let UserSession = require('./UserSession');
let Q = require('q');
let Tracker = require('./Tracking/Tracker');


module.exports = Subscribe;

//check if Create ActionResult is called
function Subscribe() {
    var clickable = true;

    const signoutRedirectDestination = jnfroutesconfg.ServerUrl;

    var subscribeField = $('.sign-up-popup');
    var registerForm = subscribeField.find('.register-form');
    var menuBar = $('.jnf-widget.jnf-widget-menu-1')[0];
    var menuHeight = $(menuBar).outerHeight();

    var darkField = $('.dark-field');
    var mobileMenuButton = $('.menu-button');
    var dropDownMenu = $('.jnf-widget-mobile-menu');
    var close = $('.dropdown-on-mobile > .close');
    var signUp = $('.sign-up');
    var signUpPopup = $('.sign-up-popup');
    var signUpClose = $('.sign-up.close');

    subscribeField.appendTo("body");
    darkField.appendTo("body");

    while ($('.sign-up-popup').length > 1) {
        $(subscribeField[0]).remove();
        $(darkField[0]).remove();
    }

    var darkField = $('.dark-field');
    var subscribeMenuButton = $('.jnf-widget-menu-1-account.subscribe');
    var logoutMenuButton = $('.jnf-widget-menu-1-account.logout');
    var loadingIndicator = $('.jnf-widget-menu-1-account.loading-indicator');

    var subscribeButton = $('#create');

    let userSession = new UserSession();
    logoutMenuButton.click(e => {
        logoutMenuButton.hide();
        loadingIndicator.addClass('visible');
        userSession.signOut().then(() => {
            window.location.href = signoutRedirectDestination;
        })
        .catch(error => {
            console.log(error);
            logoutMenuButton.show();
            loadingIndicator.removeClass('visible');
        })
        .done();
    });

    subscribeMenuButton.on('click', function (e) {
        e.stopPropagation();
        darkField.css('display', 'block');
        registerForm.css('top', menuHeight);
        subscribeField.css('display', 'block');
        dropDownMenu.removeClass('jnf-widget-mobile-menu-visible');
    });

    signUpClose.on('click', function () {
        darkField.add(subscribeField).css('display', 'none');
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest(subscribeField).length && !$(event.target).closest(subscribeMenuButton).length) {
            darkField.add(subscribeField).css('display', 'none');
        }
    });

    $("#emailRegister").on('keydown', function () {
        if ($('#emailRegister + .field-validation-valid').length > 0) {
            if ($('#emailRegister + .field-validation-valid').html().length > 1) {
                $(".server-response-container").html("");
            }
        }
        if ($('#emailRegister + .field-validation-error').length > 0) {
            if ($('#emailRegister + .field-validation-error').html().length > 1) {
                $(".server-response-container").html("");
            }
        }
    });

    subscribeButton.on('click submit', function (e) {
        e.preventDefault();
        if (clickable) {
            clickable = false;
            var registerButton = $(this);
            if ($("#emailRegister").valid()) {
                registerButton.html('<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>').addClass('sending-request');
                var givenEmail = $("#emailRegister").val();
                var emailAddress = {
                    email: givenEmail
                }
                $.ajax({
                    type: 'POST',
                    url: REGISTERPAGE + "/Register",
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify(emailAddress),
                    success: function (result, args) {
                        if (result.Result === 1) {
                            $("#emailRegister-error").html("");
                            $(".server-response-container").html("Error");
                            clickable = true;
                            registerButton.removeClass('sending-request').html('SUBSCRIBE');
                        }
                        else if (result.Result === 0) {
                            $(".server-response-container").html("");
                            $("#registerFrom").html("Confirmation email has been sent. Check your mailbox");
                            clickable = true;
                            registerButton.removeClass('sending-request').html('SUBSCRIBE');                            
                        }
                        else if (result.Result === 2) {
                            $(".server-response-container").html("");
                            $("#registerFrom").html("Thank you for subscribing");
                            clickable = true;
                            registerButton.removeClass('sending-request').html('SUBSCRIBE');
                        }
                        console.log(result);
                        console.log(args);
                    },
                    error: function (error) {
                        console.log(error);
                        registerButton.removeClass('sending-request').html('SUBSCRIBE');

                    }
                });
                Tracker.subscribeFormSent();
            }
        }

    });
}
